import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyYen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCurrencyYen"><Path d="M19.4102 3.8916L13.3154 11H18V13H13V15H18V17H13V21H11V17H6V15H11V13H6V11H10.6846L4.58984 3.8916L6.1084 2.58984L12 9.46387L17.8916 2.58984L19.4102 3.8916Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCurrencyYen;
